import { WebSocketEventData } from '../custom-event/types';
import { GatewayRequestType, GatewayResponseType } from '../web-socket/types';

import { BaseMDSSubscriptionService } from './BaseMDSSubscription.service';

/**
 * Market Data Summary Subscription Service
 */
export class MDSSubscriptionService extends BaseMDSSubscriptionService {
  private static instance: MDSSubscriptionService | undefined;

  // Make the constructor private, to have a single instance
  // eslint-disable-next-line no-useless-constructor
  private constructor() {
    super();
  }

  static getInstance(): MDSSubscriptionService {
    this.instance ??= new MDSSubscriptionService();
    return this.instance;
  }

  protected shouldHandleResponse(event: WebSocketEventData<any>): boolean {
    return event.data?.messageType === this.getResponseType();
  }

  protected getSubscriptionRequestType(): GatewayRequestType {
    return GatewayRequestType.MarketDataSummary;
  }

  protected getUnsubscriptionRequestType(): GatewayRequestType {
    return GatewayRequestType.None;
  }

  protected getResponseType(): GatewayResponseType {
    return GatewayResponseType.DataSummaryResponse;
  }
}
